export type LoginTimingResult = '成功' | '失败' | '空响应' | '已开始跳转' | '未跳转';

export const now = () => (
  typeof performance !== 'undefined' && typeof performance.now === 'function' ?
    performance.now() :
    Date.now()
);

export const elapsedMs = (startedAt: number, finishedAt: number) => (
  Math.max(0, Math.round(finishedAt - startedAt))
);

export const logLoginTiming = (
  stage: string,
  durationMs: number,
  result: LoginTimingResult,
) => {
  console.info(`【登录耗时】${stage}耗时：${durationMs}ms，结果：${result}`);
};

export const measureLoginRequest = async <T>(
  stage: string,
  request: () => Promise<T>,
  getResult: (response: T) => LoginTimingResult,
) => {
  const requestStartedAt = now();

  try {
    const response = await request();
    logLoginTiming(stage, elapsedMs(requestStartedAt, now()), getResult(response));
    return response;
  } catch (error) {
    logLoginTiming(stage, elapsedMs(requestStartedAt, now()), '失败');
    throw error;
  }
};
